<app-orders-nav [activeMenuItem]="'orders_to_export'"></app-orders-nav>


<mat-card class="content-card">
  <mat-card-title>
    {{ dataSource?.length }} Orders to export
  </mat-card-title>

  <div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; padding-right: 15px;">
    <div class="mr-1">
      <a class="mr-1" mat-raised-button color="basic" (click)="returnBack()">Back</a>
    </div>
    <div class="text-right">

      <div style="display: inline-block; margin-right: 10px; vertical-align: top;">
      <button class="mr-1"
        *appHasRoles="['admin']"
        mat-raised-button color="blue"
        [disabled]="!dataSource.data || dataSource.data.length == 0"
        (click)="exportAllOrders()">
        <mat-icon>download</mat-icon>
        Download Export CSV for {{ dataSource?.length }} orders
      </button>
      </div>
      <div style="display: inline-block; margin-right: 10px; vertical-align: top;">
        <button
          *appHasRoles="['admin']"
          mat-raised-button color="blue"
          [disabled]="!dataSource.data || dataSource.data.length == 0 || _isSendingOrdersToPortal"
          (click)="sendAllOrdersToPortal()"
          [class.spinner]="_isSendingOrdersToPortal"
        >
          <mat-icon>cloud_upload</mat-icon>
          Send {{ dataSource?.length }} orders to Portal *
        </button> <br /> <span style="background-color: rgba(139,195,74,0.5); padding: 4px; font-size: .7em; border-radius: 4px;">* Will create a Card Create Batch and process it</span>
      </div>
      <div style="display: inline-block; margin-right: 10px; vertical-align: top;">
      <button
        *appHasRoles="['admin']"
        mat-raised-button color="primary"
        (click)="goToCardCreations()"
      >
        <mat-icon>list</mat-icon>
        Card creations
      </button>
      </div>
    </div>
  </div>


  <app-mat-table-generator #table
                           tableName="ordersExportAllTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [multiselectEnabled]="false"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           >
  </app-mat-table-generator>
</mat-card>
